import { Injectable } from '@angular/core';
import { Storage }    from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class ModelService {
  
  constructor(private storage: Storage) {}

  // criar chave do nivel inicial do storage (variaveis logged e etc)
  async setRoot(key: any, data: any): Promise<boolean> {
    let success = false;

    await this.storage.set(key, data)
      .then(function () {
        success = true;
      });
  
    return success;
  }

  // retornar chave do nivel inicial do storage (variaveis logged e etc)
  async getRoot(key: any): Promise<boolean> {
    let data: any = await this.storage.get(key);

    return data;

  }

  // migrar função antiga -- deletar quando subistituir nas views
  async create(key: any, data: any): Promise<boolean> {
    return this.set(key, data);
  }

  async set(key: any, data: any): Promise<boolean> {

    let result = false;

    // Recuperar a chave (hash) do usuário logado
    const userStorageKey: any = await this.getRoot('loggedUser');

    if(userStorageKey != null) {
      
      // Recuperar os dados do usuario
      const userStorageData: any = await this.getRoot(userStorageKey); 

      userStorageData[key] = data;

      // console.log(userStorageData);
      
      await this.storage.set(userStorageKey, userStorageData)
        .then(function () {
          result = true;
          // console.log('sucesso ao salvar no storage');
        })
        .catch((error) => {
          // console.log('Erro ao salvar no storage');
          console.log(error);
        })
    }

    return result;
  }


  /* 
    Pegar dados do Storage (melhorar essa função, tá só fazendo o básico)

    @Params <String> key (como nome da chave de entrada no storage, ex. cursos), 
            <any> value(opcional)
    @Return Promise<Any>
  */
  async get(key: string, value?: any): Promise<any> {
    
    let data = null;

    // Recuperar a chave (hash) do usuário logado
    const userStorageKey: any = await this.getRoot('loggedUser');

    if(userStorageKey != null) {
      // Recuperar os dados do usuario
      const userStorageData: any = await this.getRoot(userStorageKey); 

      // Checar se existem dados do usuário e se existe uma entrada nos dados com a chave informada
      if(userStorageData != null && userStorageData[key] != null) data = userStorageData[key];

    }

    return data;

    // let data: any = await this.storage.get(key);

    // if(value != null) {
   
    //   const colArray = value.split('|');
         
    //   if(colArray == null || colArray.length != 2) {
          
    //     data = null;

    //   } else {
        
    //     const colName  = colArray[0],
    //           colValue = colArray[1];

    //     await this.storage.get(key).then((response) => {
    //         // console.log(response);

    //         // response.forEach(entrie => {
    //         //   if(entrie[colName] == null) { break };
              
    //         //   const thisValue =  entrie[colName];
    //         //   if(thisValue == colValue) {
    //         //       data = entrie;
    //         //       break;
    //         //   }
    //         // });
    //     });
    //   }
    // } 
    
    // // Comentar aqui
    // // if(data != null)   console.log('dados do local storage');
    // // Comentar aqui

    // return data;
  }

  /**  
    * Pegar todos os dados de uma chave do Storage (melhorar essa função, tá só fazendo o básico)

    * @Params <String> key (como nome da chave de entrada no storage, ex. cursos)
    * @Return Promise<Any>
  */
  async getAll(key: string): Promise<any> {
    const data = await this.storage.get(key);
    
    return data;
  }

  /**  
   * Retornar entrada de acordo com par [chave, valor]
   * 
   * @Params <String> key (como nome da chave de entrada no storage, ex. cursos), <array> [pairKey, pairValue] (ex.: id, 1 - vai procurar id == 1), <boolean> root
   * @Return Promise<Any>
   */
  async getBy(key: string, [pairKey, pairValue]: any, root: boolean = false): Promise<any> {
    let storedData = (root === true) ? await this.getRoot(key) : await this.get(key),
          data: any = null;

    if(storedData != null) {
      Object.values(storedData).forEach((key: any, value: number) => {
          if(key[pairKey] == pairValue) {
             data = Object.assign({}, key);
          } 
      })
    }

    return data;
  }

  /**  
   * Remover item de entrada de acordo com par [chave, valor]
   * 
   * @Params <String> key (como nome da chave de entrada no storage, ex. cursos), <array> [pairKey, pairValue] (ex.: id, 1 - vai procurar id == 1), <boolean> root
   * @Return Promise<Any>
   */
  async removeBy(key: string, [pairKey, pairValue]: any, root: boolean = false): Promise<any> {
    let storedData  = (root === true) ? await this.getRoot(key) : await this.get(key),
        data: any = {
          success: false,
          content: null,
          message: 'Nenhum dado removido'
        };

    if(storedData != null) {
      Object.values(storedData).forEach((key: any, value: number) => {
          if(key[pairKey] == pairValue) {
            
            delete (storedData[key])

            data.success = true;
            data.content = Object.assign({}, storedData);
            data.message = 'Item removido com sucesso';
            
          } 
      })
    }

    // Armazenar novamente os dados no storage
    if(data.success === true) {
      (root === true) ? await this.setRoot(key, data.content) : await this.set(key, data.content);
    }

    return data;
  }

  /** 
    Remover dados do storage de uma chave especifica

   * @Params <string> key (como nome da chave de entrada no storage, ex. cursos)
   * @Params <object> pair (nome do campo e valor. E.: {id: 100})
   * @Return Promise<Any>
   * @author Demerson Carvalho
   */
  async remove(key: string, pair: any): Promise<any> {

    // return await this.storage.remove(key);
  }

  /**  
   * Remover dados do storage de uma chave especifica
   * 
   * @Params <String>keyName - nome da chave no storage, <boolean> root (default false) - se o item está no primeiro nivel do storage (chaves comuns, ex: loggedUser)
   * @Return Promise<Any>
   * @author Demerson Carvalho
   */
  async drop(keyName: string, root: boolean = false): Promise<any> {
    const data: any = {
      success: false,
      message: 'Nenhum item removido'
    };

    // Caso o a chave esteja no primeiro nivel do storage (chave comum, Ex.: loggedUser)
    if(root === true){
        data.success = (await this.storage.remove(keyName) == null) ? true : false;
        data.message = (data.success === true ) ? 'Item removido com sucesso' : 'Erro ao remover item';

        return data;
    }

    const userStorageKey: any  = await this.getRoot('loggedUser'),
          userStoragedata: any = await this.getRoot(userStorageKey);

    if(userStorageKey != null) {
      Object.entries(userStoragedata).forEach((key: any, value: any) => {
    
          // key[0] é o nome da entrada do objeto - key[1] armazena os valores, caso existam
          if(key[0] == keyName) {
              delete userStoragedata[keyName];

           

              data.success = true;
              data.message = 'Item removido com sucesso';
          }
      });
    } 

    // Se obteve sucesso ao remover o item do ojeto, setar novamente o storage do usuario
    if(data.success == true) {
        data.success = (await this.setRoot(userStorageKey, userStoragedata) === true) ? true : false;
        data.message = (data.success === true) ? 'Item nullado com sucesso' : 'Erro ao nullar item';
    }

    return data;

  }

  /**  
   * Nular valor no storage de uma chave especifica
   * 
   * @Params <String>keyName - nome da chave no storage, <boolean> root (default false) - se o item está no primeiro nivel do storage (chaves comuns, ex: loggedUser)
   * @Return Promise<Any>
   * @author Demerson Carvalho
   */
  async truncate(keyName: string, root: boolean = false): Promise<any> { 
    
    const data: any = {
      success: false,
      message: 'Nenhum item nullado'
    };

    // Caso o a chave esteja no primeiro nivel do storage (chave comum, Ex.: loggedUser)
    if(root === true){
        data.success = (await this.setRoot(keyName, null) === true) ? true : false;
        data.message = (data.success === true) ? 'Item nullado com sucesso' : 'Erro ao nullar item';

        // console.log(keyName);
        // console.log(data);
        // await this.entries();
        
        return data;
    }

    const userStorageKey: any  = await this.getRoot('loggedUser');
    const userStoragedata: any = await this.getRoot(userStorageKey);

    if(userStorageKey != null) {
      Object.entries(userStoragedata).forEach((key: any, value: any) => {
     
          // key[0] é o nome da entrada do objeto - key[1] armazena os valores, caso existam
          if(key[0] == keyName) {
              userStoragedata[keyName] = null;
              data.success = true;
          }
      });
    }

    // Se obteve sucesso ao remover o item, setar novamente o storage do usuario
    if(data.success == true) {    
        data.success = (await this.setRoot(userStorageKey, userStoragedata) === true) ? true : false;
        data.message = (data.success === true) ? 'Item nullado com sucesso' : 'Erro ao nullar item';
    }

    return data;
    
  }
  
  /**  
   * Limpar todo o Storage
   * 
   * @Return Promise<Any>
   * @author Demerson Carvalho
   */
  async clearAll() {
      this.storage.clear().then(() => {
        window.localStorage.clear();
        // this.entries();  
      
        setTimeout(() => { window.location.reload() }, 500)
      });
  } 

  /**  
   * Pegar todas as chaves do Storage e retornar com seus valores
   * 
   * @Return Promise<Any>
   */
  async entries(): Promise<any> {

    const database: {} = {};
    
    this.storage.forEach((value, keyName) => {
        database[keyName] = value;
    })
    .then(() => {
      console.log(database);
    })
  }
}
